import { SiteStore } from '~/stores/site'
import { StoreInit } from '~/composables/StoreInit'
import { SessionStore } from '~/stores/session'
import { FeatureFlags } from '~/composables/FeatureFlags'
import { SignInResult, VerifyResult } from '~/generated/api-clients-generated'

export class AppInit {
  static async use() {
    const site = SiteStore.use()
    const { signInSoft, verifyMagicLink, returnRedirect, signInRedirect } = Auth.use()
    const { journeyId, route } = AppRoute.use()
    const config = useRuntimeConfig()
    const cookieJourneyId = useCookie(`${config.public.cookieEnvPrefix}journey_id`)

    const { flag } = FeatureFlags.use()
    const siteConfig = flag<any>('site-config').value

    let activeJourneyId = 0
    if (!_isNil(journeyId.value) && siteConfig.active_journey_ids.includes(journeyId.value)) {
      activeJourneyId = journeyId.value
    } else if (cookieJourneyId.value) {
      const jid = parseInt(cookieJourneyId.value)

      if (siteConfig.active_journey_ids.includes(jid)) {
        activeJourneyId = jid
      } else {
        activeJourneyId = siteConfig.default_journey_id
      }
    } else {
      activeJourneyId = flag('journey-id', siteConfig.default_journey_id).value
    }

    cookieJourneyId.value = activeJourneyId.toString()

    site.load(activeJourneyId)

    const isMagicLink = !!route.query.magic_link
    let magicLinkResult = null

    if (isMagicLink) {
      const { isRobot } = RickDeckard.use()
      if (!isRobot()) {
        try {
          magicLinkResult = await verifyMagicLink(route.query.magic_link as string)
        } catch (e) {
          magicLinkResult = VerifyResult.Error
        }
      } else {
        magicLinkResult = VerifyResult.Error
      }
    }

    await StoreInit.use(!isMagicLink)

    const session = SessionStore.use()

    if (!_isEmpty(route.query)) {
      session.params = _mapValues(
        {
          ...session.params,
          ...route.query
        },
        (x) => (_isArray(x) ? _first(x) : _isObject(x) ? null : x)
      )

      if (!!route.query.application_id) {
        session.currentApplicationId = route.query.application_id as string
      }
    }

    session.zipCode ??= session.params.zip_code ?? null

    if (!('journey-id' in session.flags)) {
      session.captureFlag('journey_id', activeJourneyId)
    }

    const cookieProfileId = useCookie(`${config.public.cookieEnvPrefix}www_profile_id`, {
      path: '/',
      domain: '.healthpilot.com',
      maxAge: 86400,
      secure: true,
      sameSite: 'lax'
    })

    if (cookieProfileId.value) {
      session.profileId = cookieProfileId.value
      console.log('session.profileId', session.profileId)

      await SessionStore.save()

      const resp = await signInSoft(cookieProfileId.value)

      if (resp.result !== SignInResult.Soft) {
        console.error('failed to soft sign-in: ', resp)
        return
      }

      await SessionStore.load()

      console.log('DELETE COOKIE')
      // delete cookie after signing in
      // this won't work with the healthpilot.dev domain
      cookieProfileId.value = null
    }

    if (isMagicLink) {
      switch (magicLinkResult) {
        case VerifyResult.Success:
          await returnRedirect()
          break
        default:
          await signInRedirect()
      }

      setTimeout(() => {
        session.sync = true
      }, 1000)
    }
  }
}
